<div class="container">
  @if (shippingMethod()) {
    <div class="header">
      @if (shippingMethod() === ShippingMethod.Delivery) {
        <button
          class="header__switch"
          (click)="toggleShippingMethod(ShippingMethod.Pickup)"
        >
          <i class="icon icon-bag-outline"></i>
          <span class="header__switch_label">I want pickup instead</span>
        </button>
      } @else if (shippingMethod() === ShippingMethod.Pickup) {
        <button
          class="header__switch"
          (click)="toggleShippingMethod(ShippingMethod.Delivery)"
        >
          <i class="icon icon-delivery-outline"></i>
          <span class="header__switch_label">I want delivery instead</span>
        </button>
      }
    </div>
  }

  <div class="content">
    @if (shippingMethod() == '') {
      <ul class="content__delivery-method">
        @for (deliveryMethodOption of SHIPPING_OPTIONS(); track $index) {
          <li class="content__delivery-method_item">
            <app-radio-card
              name="deliveryMethod"
              [icon]="deliveryMethodOption.icon || ''"
              [label]="deliveryMethodOption.name"
              [description]="deliveryMethodOption.description || ''"
              [radioValue]="deliveryMethodOption.id"
              [ngModel]="shippingMethod()"
              (ngModelChange)="toggleShippingMethod($event)"
            />
          </li>
        }
      </ul>
    }

    @if (shippingMethod() === ShippingMethod.Delivery) {
      <div class="content__delivery">
        <div class="content__delivery_label">
          <i class="icon icon-delivery-outline"></i>
          <span class="content__delivery_label_name">Delivery</span>
        </div>

        <app-input-address
          [size]="InputAddressSize.Medium"
          [(isShippingAvailable)]="isDeliveryAddressAvailable"
          [(ngModel)]="deliveryAddress"
          (ngModelChange)="
            onSelectedAddressChange($event, ShippingMethod.Delivery)
          "
        />
      </div>

      @if (!isDeliveryAddressAvailable()) {
        <div class="content__options">
          <app-address-select
            [addresses]="pickupAddresses() || []"
            [(ngModel)]="selectedPickupAddress"
            (ngModelChange)="onSelectedAddressChange($event)"
          />
        </div>
      }
    }

    @if (shippingMethod() === ShippingMethod.Pickup) {
      <div class="content__pickup">
        <app-address-select
          [addresses]="pickupAddresses() || []"
          [(ngModel)]="selectedPickupAddress"
          (ngModelChange)="onSelectedAddressChange($event)"
        />
      </div>
    }
  </div>
</div>
